import { addLoading } from "./index";
import { getLoadingNameByActionType } from "./utiles";

function action(actionType) {
  const loadingName = getLoadingNameByActionType(actionType);

  // 不传loadingName 后面需要actionType来hook action
  addLoading(actionType);

  return function() {
    return this.$store.state.loadings[loadingName];
  };
}
export default fn => {
  return fn({ action });
};
